<div class="card d-flex flex-column flex-grow-1">
  <div *ngIf="formGroup$ | async as formGroup" class="card-body d-flex flex-column flex-grow-1">
    <ng-container *ngIf="formGroup.statusChanges | async"></ng-container>
    <ng-container *ngIf="viewModel$ | async as vm">
      <form [formGroup]="formGroup">
        <div class="row">
          <div class="col-auto">
            <div class="card">
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="salutation">Title</label>
                    <select id="salutation" formControlName="salutation" class="form-control w-6rem">
                      <option value="Dr">Dr</option>
                      <option value="Miss">Miss</option>
                      <option value="Mr">Mr</option>
                      <option value="Mrs">Mrs</option>
                      <option value="Ms">Ms</option>
                      <option value="Mx">Mx</option>
                    </select>
                  </div>
                  <div class="form-group col-auto">
                    <label for="first">First</label>
                    <input id="first" formControlName="first" type="text" class="form-control w-17rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="last">Last</label>
                    <input id="last" formControlName="last" type="text" class="form-control w-17rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto" *libHasClaim="Unity4Claim.AccountDetails">
                    <label for="dob">DOB</label>
                    <input id="dob" formControlName="dob" type="date" [min]="minDob | date: 'yyyy-MM-dd'"
                      [max]="maxDob | date: 'yyyy-MM-dd'" class="form-control w-105rem" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="address1">Address</label>
                    <input id="address1" formControlName="address" type="text" class="form-control w-35rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <input id="address2" formControlName="address2" type="text" class="form-control w-35rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="suburb">
                      {{ vm.isUK || vm.isCA ? "City" : "Suburb" }}
                    </label>
                    <input id="suburb" formControlName="suburb" type="text" class="form-control w-15rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <ng-container [ngSwitch]="true">
                    <div *ngSwitchCase="vm.isNZ" class="form-group col-auto">
                      <label for="state">City/Town</label>
                      <input id="state" formControlName="state" type="text" class="form-control w-15rem"
                        autocomplete="off" aria-autocomplete="list" />
                    </div>
                    <div *ngSwitchCase="vm.isUK" class="form-group col-auto">
                      <label for="state">County</label>
                      <input id="state" formControlName="state" type="text" class="form-control w-15rem"
                        autocomplete="off" aria-autocomplete="list" />
                    </div>
                    <div *ngSwitchCase="vm.isCA" class="form-group col-auto">
                      <label for="province">Province</label>
                      <select id="province" formControlName="state" class="form-control w-16rem">
                        <option value="AB">Alberta</option>
                        <option value="BC">British Columbia</option>
                        <option value="MB">Manitoba</option>
                        <option value="NB">New Brunswick</option>
                        <option value="NL">Newfoundland And Labrador</option>
                        <option value="NT">Northwest Territories</option>
                        <option value="NS">Nova Scotia</option>
                        <option value="NU">Nunavut</option>
                        <option value="On">Ontario</option>
                        <option value="PE">Prince Edward Island</option>
                        <option value="QC">Quebec</option>
                        <option value="SK">Saskatchewan</option>
                        <option value="YT">Yukon</option>
                      </select>
                    </div>
                    <ng-container *ngSwitchCase="vm.isFJ"></ng-container>
                    <div *ngSwitchDefault class="form-group col-auto">
                      <label for="state">State</label>
                      <select id="state" formControlName="state" class="form-control w-6rem">
                        <option value="ACT">ACT</option>
                        <option value="NSW">NSW</option>
                        <option value="NT">NT</option>
                        <option value="QLD">QLD</option>
                        <option value="SA">SA</option>
                        <option value="TAS">TAS</option>
                        <option value="VIC">VIC</option>
                        <option value="WA">WA</option>
                      </select>
                    </div>
                  </ng-container>

                  <div class="form-group col-auto">
                    <label for="postcode">Postcode</label>
                    <input id="postcode" formControlName="postcode" type="text" class="form-control"
                      [ngClass]="vm.isCA || vm.isUK ? 'w-8rem' : 'w-4rem'" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="country">Country</label>
                    <input id="country" [value]="vm.country" type="text" class="form-control w-105rem" readonly />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="phone1">Landline</label>
                    <div class="input-group">
                      <input id="phone1" formControlName="phone1" type="text" class="form-control w-12rem"
                        autocomplete="off" aria-autocomplete="list" />
                    </div>
                  </div>

                  <div class="form-group col-auto">
                    <label for="mobile">
                      {{ vm.isCA ? "Cell" : "Mobile" }}
                    </label>
                    <div class="input-group">
                      <input id="mobile" formControlName="mobile" type="text" class="form-control w-12rem"
                        autocomplete="off" aria-autocomplete="list" />
                    </div>
                  </div>
                  <div class="form-group col-auto">
                    <label for="telephony">Telephony</label>
                    <input id="telephony" formControlName="telephony" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="email">Email</label>
                    <input id="email" formControlName="email" type="text" class="form-control w-22rem" size="30"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="card">
              <div class="card-header">Avatar</div>
              <div class="card-body">
                <img [src]="userId$ | async | userAvatar: true | async" alt="user" class="rounded large-avatar" />
                <div class="avatar-upload-overlay">
                  <input #avatarUpload type="file" class="custom-file-input avatar-upload" ngFileSelect
                    [options]="options" (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput" />
                </div>
                <div class="avatar-reset text-center">
                  <button type="button" class="btn btn-sm btn-secondary" (click)="showResetConfirmation()">
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto" *libHasClaim="Unity4Claim.AccountDetails">
            <div class="card" [ngSwitch]="true">
              <div class="card-header">Account Details</div>
              <div class="card-body" *ngSwitchCase="vm.isNZ">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountname">Account Holder</label>
                    <input id="accountname" formControlName="accountName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="bank">Bank</label>
                    <input id="bank" formControlName="bank" type="text" class="form-control w-4rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="branch">Branch</label>
                    <input id="branch" formControlName="branch" type="text" class="form-control w-6rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="account">Account Number</label>
                    <input id="accountNumber" formControlName="accountNumber" type="text" class="form-control w-8rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="suffix">Suffix</label>
                    <input id="suffix" formControlName="bsb" type="text" class="form-control w-4rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                </div>
              </div>
              <div class="card-body" *ngSwitchCase="vm.isUK">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountname">Account Holder</label>
                    <input id="accountname" formControlName="accountName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="sortcode">Sort Code</label>
                    <input id="sortcode" formControlName="bsb" type="text" class="form-control w-8rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="accountnumber">Number</label>
                    <input id="accountnumber" formControlName="accountNumber" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="bank">Bank</label>
                    <input id="bank" formControlName="bank" type="text" class="form-control" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="branch">Branch</label>
                    <input id="branch" formControlName="branch" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-auto">
                    <label for="nino">NINO</label>
                    <input id="nino" formControlName="tfn" type="text" class="form-control w-12rem"
                      placeholder="eg. QQ123456C" autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
              </div>
              <div class="card-body" *ngSwitchCase="vm.isCA">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountname">Account Holder</label>
                    <input id="accountname" formControlName="accountName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="transit">Transit</label>
                    <input id="transit" formControlName="bsb" type="text" class="form-control w-6rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="institution">Financial Institution</label>
                    <input id="institution" formControlName="branch" type="text" class="form-control w-6rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="account">Account</label>
                    <input id="account" formControlName="accountNumber" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
              </div>
              <div class="card-body" *ngSwitchCase="vm.isFJ">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountname">Account Holder</label>
                    <input id="accountname" formControlName="accountName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountnumber">Number</label>
                    <input id="accountnumber" formControlName="accountNumber" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="bank">Bank</label>
                    <select id="bank" formControlName="bank" class="form-control w-12rem">
                      <option value="ANZ">ANZ</option>
                      <option value="Westpac">Westpac</option>
                      <option value="Bank of Baroda">Bank of Baroda</option>
                      <option value="BRED Bank">BRED Bank</option>
                      <option value="BSP">BSP</option>
                      <option value="HFC Bank">HFC Bank</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-body" *ngSwitchDefault>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="accountname">Account Holder</label>
                    <input id="accountname" formControlName="accountName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="bsb">BSB</label>
                    <input id="bsb" formControlName="bsb" type="text" class="form-control w-8rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="accountnumber">Number</label>
                    <input id="accountnumber" formControlName="accountNumber" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="bank">Bank</label>
                    <input id="bank" formControlName="bank" type="text" class="form-control w-12rem" autocomplete="off"
                      aria-autocomplete="list" />
                  </div>
                  <div class="form-group col-auto">
                    <label for="branch">Branch</label>
                    <input id="branch" formControlName="branch" type="text" class="form-control w-12rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto" *libHasClaim="Unity4Claim.EmergencyContact">
            <div class="card">
              <div class="card-header">Emergency Contact</div>
              <div class="card-body">
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="emergencyname">Name</label>
                    <input id="emergencyname" formControlName="emergencyName" type="text" class="form-control w-22rem"
                      autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-auto">
                    <label for="emergencyrelationship">Relationship</label>
                    <input id="emergencyrelationship" formControlName="emergencyRelationship" type="text"
                      class="form-control w-12rem" autocomplete="off" aria-autocomplete="list" />
                  </div>

                  <div class="form-group col-auto">
                    <label for="emergencycontact">Number</label>
                    <input id="emergencycontact" formControlName="emergencyContact" type="text"
                      class="form-control w-12rem" autocomplete="off" aria-autocomplete="list" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto">
            <button type="button" class="btn btn-primary" [disabled]="formGroup.invalid"
              (click)="this.updateContactDetails()">
              Update
            </button>
            <button type="button" class="btn btn-secondary ml-2" (click)="this.openResetPasswordModal()">
              Change Password
            </button>
          </div>
        </div>
      </form>
    </ng-container>
  </div>
</div>